import { useEffect } from 'react'
import { useSpring } from 'react-spring'

// import theme from '@/styles/theme';

const isBrowser = typeof window !== 'undefined'

const getScrollTargetY = element => {
  const elementOffset = element.offsetTop - 64

  // +1 makes the animation seem smoother
  return elementOffset + 1
}

export default () => {
  // fallback for SSR
  if (!isBrowser) {
    return [() => {}]
  }

  // initialization (no animation happens)
  const [, setScrollAnimation, stopScrollAnimation] = useSpring(() => ({
    to: { y: window.pageYOffset },
    onFrame: ({ y }) => {
      window.scroll(0, y)
    },
  }))

  // stop animation on user intervention
  useEffect(() => {
    window.addEventListener('wheel', stopScrollAnimation)
    window.addEventListener('touchstart', stopScrollAnimation)

    return () => {
      window.removeEventListener('wheel', stopScrollAnimation)
      window.removeEventListener('touchstart', stopScrollAnimation)
    }
  }, [stopScrollAnimation])

  // target can be number or ref
  return [
    target => {
      const scrollTargetY =
        typeof target === 'number' ? target : getScrollTargetY(target)
      // scroll from current scroll position
      setScrollAnimation({
        from: { y: window.pageYOffset },
        to: { y: scrollTargetY },
        reset: true,
      })

      return null
    },
  ]
}
